import { locale } from "../../../services/LocaleService.js";

/**
 * SearchBar Component
 * @param {Function} onSearch - Callback(query)
 */
export const SearchBar = (onSearch) => {
    const container = document.createElement('div');
    container.className = "relative group mb-6";

    container.innerHTML = `
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span class="material-symbols-outlined text-gray-400 group-focus-within:text-indigo-500 transition-colors">search</span>
        </div>
        <input type="text" id="home-search-input" name="homeSearch" aria-label="Search for works, authors, and tags"
            class="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-2xl leading-5 bg-gray-50 text-gray-900 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 transition-all shadow-sm"
            placeholder="${locale.t('main.search_placeholder')}" autocomplete="off">
    `;

    const input = container.querySelector('input');
    let debounceTimer;

    input.oninput = (e) => {
        const val = e.target.value;
        const btnClear = container.querySelector('#btn-search-clear');
        if (val.length > 0) {
            btnClear.classList.remove('hidden');
        } else {
            btnClear.classList.add('hidden');
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            if (onSearch) onSearch(val);
        }, 150); // Fast debounce for instant feel
    };

    // Clear Button Event
    const btnClear = document.createElement('button');
    btnClear.id = 'btn-search-clear';
    btnClear.className = "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 cursor-pointer hidden";
    btnClear.setAttribute('aria-label', 'Clear search');
    btnClear.innerHTML = '<span class="material-symbols-outlined" aria-hidden="true">cancel</span>'; // cancel icon
    btnClear.onclick = () => {
        clearTimeout(debounceTimer); // Stop any pending search
        input.value = '';
        input.focus();
        btnClear.classList.add('hidden');
        if (onSearch) onSearch('');
    };
    container.appendChild(btnClear);

    return { element: container, input };
};
